export interface EventOccurrence {
  from: string;
  has_time: boolean;
  to: string;
}
